import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchAll({ departmentParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `department/GetSearched`,
      params: departmentParams,
    });
    const allDepartment = data;
    yield put(Actions.setAll({ allDepartment }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addorUpdateDepartment({ departmentData, actionName, departmentParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(actionName === 'Update' ? api.put : api.post, {
      route: `department`,
      data: departmentData,
    });
    yield put(Actions.fetchAll({ departmentParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD
        ? CONSTANT_VARIABLES.DEPARTMENT_CREATED
        : CONSTANT_VARIABLES.DEPARTMENT_UPDATED,
      ''
    );
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteDepartment({ id, departmentParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `department/${id}`,
    });
    yield put(Actions.fetchAll({ departmentParams }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.toString(), '');
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([takeLatest(ActionTypes.FETCH_ALL, fetchAll)]);
  yield all([takeLatest(ActionTypes.ADD_OR_UPDATE_DEPARTMENT, addorUpdateDepartment)]);
  yield all([takeLatest(ActionTypes.DELETE_DEPARTMENT, deleteDepartment)]);
}
